module.exports = __webpack_public_path__ + "media/map/KY_Icon-b3cb55e7.png";